function getBucketConfig(): { url: string; key: string } | null {
  const url = (import.meta.env.VITE_BUCKET_BASE_URL as string | undefined)?.replace(/\/$/, "");
  const key = import.meta.env.VITE_BUCKET_SECRET_KEY as string | undefined;
  if (!url || !key) return null;
  return { url, key };
}

function bucketNotConfigured() {
  return { ok: false as const, message: "Bucket non configuré (VITE_BUCKET_BASE_URL / VITE_BUCKET_SECRET_KEY manquants dans .env)." };
}

/** Upload d'un seul fichier. Retourne l'URL publique. */
export async function uploadFileToBucket(
  file: File,
  folder: string,
  filename?: string
): Promise<{ ok: true; url: string } | { ok: false; message: string }> {
  const cfg = getBucketConfig();
  if (!cfg) return bucketNotConfigured();

  const form = new FormData();
  form.append("file", file);
  form.append("secret_key", cfg.key);
  form.append("folder_name", folder);
  if (filename) form.append("filename", filename);

  try {
    const res = await fetch(`${cfg.url}/api/files/upload-file`, {
      method: "POST",
      headers: { "x-secret-key": cfg.key },
      body: form,
    });
    const json = (await res.json().catch(() => null)) as Record<string, unknown> | null;
    if (!res.ok || !json?.success) {
      return { ok: false, message: typeof json?.message === "string" ? json.message : `Erreur ${res.status}` };
    }
    const url = (json.data as Record<string, unknown>)?.url;
    if (typeof url !== "string" || !url) {
      return { ok: false, message: "URL absente dans la réponse du bucket." };
    }
    return { ok: true, url };
  } catch (err) {
    return { ok: false, message: (err as Error)?.message ?? "Erreur réseau bucket." };
  }
}

/** Upload de plusieurs fichiers (max 10, 50 Mo chacun). Retourne les URLs dans le même ordre. */
export async function uploadFilesToBucket(
  files: File[],
  folder: string
): Promise<{ ok: true; urls: string[] } | { ok: false; message: string }> {
  const cfg = getBucketConfig();
  if (!cfg) return bucketNotConfigured();
  if (files.length === 0) return { ok: true, urls: [] };

  const form = new FormData();
  for (const file of files) form.append("files", file);
  form.append("secret_key", cfg.key);
  form.append("folder_name", folder);

  try {
    const res = await fetch(`${cfg.url}/api/files/upload-files`, {
      method: "POST",
      headers: { "x-secret-key": cfg.key },
      body: form,
    });
    const json = (await res.json().catch(() => null)) as Record<string, unknown> | null;
    if (!res.ok || !json?.success) {
      return { ok: false, message: typeof json?.message === "string" ? json.message : `Erreur ${res.status}` };
    }
    const data = json.data;
    if (!Array.isArray(data)) return { ok: false, message: "Structure de réponse inattendue." };
    const urls = (data as Record<string, unknown>[])
      .map((item) => item?.url)
      .filter((u): u is string => typeof u === "string" && !!u);
    return { ok: true, urls };
  } catch (err) {
    return { ok: false, message: (err as Error)?.message ?? "Erreur réseau bucket." };
  }
}
